import { Injectable } from '@angular/core';
import { SuiModalService } from 'ng2-semantic-ui';
import { AlertModal, ConfirmModal } from '../_shared/index';

import { ModalDialogService } from 'ngx-modal-dialog';
import { Subject } from 'rxjs';

@Injectable()
export class CustomModalService {

  constructor(
    private suiModal: SuiModalService,
    private modalDialogService: ModalDialogService
  ) { }

  alertModal(opts: any, cb: Function) {
    let modal = new AlertModal(opts.title, opts.message, opts.size);
    this.suiModal.open(modal)
      .onApprove(() => {
        cb(true);
      });
  }

  confirmModal(opts: any, cb: Function) {
    let modal = new ConfirmModal(opts.title, opts.message, opts.size);
    this.suiModal.open(modal)
      .onApprove(() => {
        cb(true);
      })
      .onDeny(() => {
        cb(false);
      });
  }

  confirmNavigation(screen: any) {
    let capitalizedScreen = screen.replace(/^\w/, c => c.toUpperCase());
    let title = `Leaving ${capitalizedScreen}`;
    let message = `Are you sure you want to leave the ${screen}? Any progress will be lost.`;
    console.log('Returning confirm navigation modal');
    
    return new ConfirmModal(title, message, 'tiny');
  }

  async customModal(options: any) {
    const dialogOptions = {
      closeDialogSubject: new Subject<any>(),
			title: options.title,
			childComponent: options.childComponent,
			data: {
				text: options.text,
				templateData: options.templateData
			},
			settings: {
				overlayClass: 'modal-backdrop fade show',
				modalDialogClass: 'ui modals dimmer active tc-custom-dimmer',
				headerClass: 'header',
				contentClass: 'ui active modal tc-custom-modal ' + options.size,
				bodyClass: 'content',
				footerClass: 'actions nowrap',
				closeButtonClass: 'custom-modal-close-btn fa fa-times-circle'
			}
		};		
    await dialogOptions.closeDialogSubject.subscribe({
      next: (data) => {
        console.log("Dialog closed and notified via subscription, data rcvd -->", data);
      }
    });
		return this.modalDialogService.openDialog(options.viewContainer, dialogOptions);
  }

}
